export function SmallLogo() {
  return <img src="/images/icon-logo-small.svg" alt="BonusX" width={25} height={13} />;
}
